<div class="question-numbers-div">
    <div class="question-number" 
        *ngFor="let record of questionRecord; let questionNumber = index" 
        [ngClass]="{
            'selected-question': questionNumber === selectedQuestionNumber,
            'marked-for-review': record.isMarkedForReview,
            'visited': record.isVisited,
            'answered': record.isAnswered
        }"
        (click)="navigateQuestion(questionNumber)">
        <div class="content">
            <div class="number">{{ questionNumber + 1 }}</div>
            @if (record.isMarkedForReview) {
                <div class="flag">🚩</div>
            }
        </div>
    </div>
</div>
